// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"112":"69c2b925","139":"559b9b5e","193":"734c3cbe","606":"3f0b3494","959":"6f766504"}[chunkId] + ".chunk.css";
};